"use strict";
/** Схемы создания и изменения проектов и состава участников. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.inviteProjectMemberSchema = exports.updateProjectMemberSchema = exports.addProjectMemberSchema = exports.listProjectsQuerySchema = exports.updateProjectSchema = exports.createProjectSchema = void 0;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
const projectNameSchema = zod_1.z
    .string()
    .trim()
    .min(1, 'Укажите название проекта')
    .max(240, 'Название не длиннее 240 символов');
exports.createProjectSchema = zod_1.z
    .object({
    workspaceId: common_1.uuidSchema,
    name: projectNameSchema,
    descriptionMd: common_1.markdownSchema.nullish(),
    /** Новый проект может быть только идеей или активной работой. */
    status: zod_1.z.enum(['IDEA', 'ACTIVE']).default('ACTIVE'),
    currentGoal: zod_1.z.string().trim().max(2000).nullish(),
    startDate: common_1.isoDateSchema.nullish(),
    targetDate: common_1.isoDateSchema.nullish(),
})
    .refine((value) => !value.startDate || !value.targetDate || value.startDate <= value.targetDate, {
    message: 'Целевая дата не может быть раньше даты начала',
    path: ['targetDate'],
});
exports.updateProjectSchema = zod_1.z.object({
    name: projectNameSchema.optional(),
    descriptionMd: common_1.markdownSchema.nullish(),
    status: zod_1.z.enum(contracts_1.PROJECT_STATUSES).optional(),
    currentGoal: zod_1.z.string().trim().max(2000).nullish(),
    startDate: common_1.isoDateSchema.nullish(),
    targetDate: common_1.isoDateSchema.nullish(),
});
exports.listProjectsQuerySchema = zod_1.z.object({
    workspaceId: common_1.uuidSchema.optional(),
    status: zod_1.z.array(zod_1.z.enum(contracts_1.PROJECT_STATUSES)).optional(),
    includeArchived: zod_1.z.coerce.boolean().default(false),
    search: zod_1.z.string().trim().max(200).optional(),
});
/** Роль, назначаемая участнику. Владелец передаётся отдельной операцией. */
const assignableRoleSchema = zod_1.z.enum(contracts_1.MEMBER_ROLES.filter((role) => role !== 'OWNER'));
exports.addProjectMemberSchema = zod_1.z.object({
    userId: common_1.uuidSchema,
    role: assignableRoleSchema,
});
exports.updateProjectMemberSchema = zod_1.z.object({
    role: assignableRoleSchema,
});
/**
 * Приглашение нового человека.
 *
 * Обязателен только адрес: приглашающий чаще всего знает именно его. Имя
 * необязательно — без него берётся часть адреса до собаки, и человек всё
 * равно виден в списке под чем-то осмысленным.
 */
exports.inviteProjectMemberSchema = zod_1.z.object({
    email: common_1.emailSchema,
    name: zod_1.z.string().trim().max(160, 'Имя не длиннее 160 символов').optional(),
    role: assignableRoleSchema,
});
//# sourceMappingURL=projects.js.map